import { Drupal, Firebase, Wordpress } from './index';
import { Storage } from '../util/storage';
declare var jDrupal;
declare var WPAPI;
declare var Promise;
declare var fetch;
declare var _;

export class Migration {

    private field_mapping: any;
    public source;
    public destination;
    public status;

    constructor() {
        this.field_mapping = {
            // 'nid[0].value': 'id',
            // 'uuid[0].value': 'guid.rendered',
            'title[0].value': 'title.rendered',
            'body[0].value': 'content.rendered',

            'created[0].value': 'date',
            'changed[0].value': 'modified',
            'sticky[0].value': 'sticky',

            'type[0].target_id': 'type',
            'moderation_state[0].target_id': 'status',

            'field_meta_tags[0[.value': 'meta'
            // '_links': '_links',
        };
    }

    public migrate(options) {
        const self = this;
        this.source = options.source;
        this.destination = options.destination;
        return new Promise(function (resolve, reject) {

        });
    }

}
